module.exports = __webpack_public_path__ + "img/symbol_kutschemitpferd.9c221c8.jpg";